// libraries.
import styled from "styled-components";
import { robotoRegular, white } from "@habitech/shared";

export const StyledWrapper = styled.div`
  .title-text,
  .text-label,
  .text-help,
  .progress-text {
    font-family: ${robotoRegular};
    font-size: 14px;
    font-weight: 400;
  }

  .text-area {
    font-family: ${robotoRegular};
    font-size: 14px;
  }

  .submit-button {
    color: ${white};
  }

  .progress-bar {
    background-color: #7c01ff;
  }
`;

